// Temporary switches for backend endpoints that are currently unavailable.
// Change the corresponding value to false to restore an endpoint.
export const TEMPORARILY_DISABLED_ENDPOINTS = Object.freeze({
  orderByTimeFrame3: true,
  customerInformation: true,
  orderCart: true,
});



// WEBPACK FOOTER //
// ./src/api/temporary_disabled_endpoints.js